class EmptyAltTags {
  constructor(options = {}) {
    const { targetSelectors = ["img:not([alt])"], timeoutSeconds = 10 } = options
    this.targetSelectors = targetSelectors
    this.timeoutSeconds = timeoutSeconds * 1000
    this.init()
  }

  init() {
    this.targetSelectors.forEach((selector) => {
      this.checkForElements(selector, this.timeoutSeconds)
    })
  }

  checkForElements(selector, timeout) {
    const startTime = Date.now()
    const interval = setInterval(() => {
      requestAnimationFrame(() => {
        const elements = document.querySelectorAll(selector)
        elements.forEach((element) => this.initEmptyAltTags(element))

        if (Date.now() - startTime > timeout) {
          clearInterval(interval)
        }
      })
    }, 300)
  }

  initEmptyAltTags(image) {
    // console.log(image.outerHTML)
    if (!image || image.tagName !== "IMG" || image.hasAttribute("alt")) return
    image.setAttribute("alt", "")
  }
}

export { EmptyAltTags }
